import { SiteCookie, SiteCookieFlag } from './types';

export const siteCookiesDescriptions: Record<SiteCookie, string> = {
  __hssc: '__hssc (HubSpot): To store anonymized statistics about website sessions',
  _gat_gtag_UA_255874618_1: '_gat_gtag_UA (Google Analytics): To store a unique user id and measure how users interact with our website',
  __cf_bm: '__cf_bm (CloudFlare): To read and filter requests from bad bots to protect the website',
  _gid: '_gid (Google Analytics): To identify the user and generate statistical data on the website use',
  __hssrc: '__hssrc (HubSpot): To store a unique session ID',
  hubspotutk: "hubspotutk (HubSpot): To keep track of a visitor's identity",
  __hstc: '__hstc (HubSpot): To store time of visit',
  _ga: '_ga (Google Analytics): To identify unique users',
};

export const siteCookiesDefaultValues: Record<SiteCookie, boolean> = {
  __hssc: true,
  _gat_gtag_UA_255874618_1: true,
  __cf_bm: true,
  _gid: true,
  __hssrc: true,
  hubspotutk: true,
  __hstc: true,
  _ga: true,
};

export const allSiteCookies: Array<SiteCookie | SiteCookieFlag> = [...(Object.keys(siteCookiesDefaultValues) as SiteCookie[]), 'gaspar'];
